(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/react/components/hero/closetime-countdown.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/react/components/hero/closetime-countdown.js');

'use strict';

const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const useCloseTimeTicker = svs.gamePackage.hooks.useCloseTimeTicker;
const TimeCell = _ref => {
  let value = _ref.value,
    label = _ref.label;
  const formattedValue = value < 10 ? "0".concat(value) : value.toString();
  return React.createElement("div", {
    className: "gp-counter-time-cell"
  }, React.createElement("span", {
    className: "gp-time-cell-value"
  }, formattedValue), React.createElement("span", {
    className: "gp-time-cell-label"
  }, label));
};
const Separator = () => React.createElement("div", {
  className: "gp-counter-separator"
}, ":");
const CloseTimeCountdown = _ref2 => {
  let useDarkBg = _ref2.useDarkBg;
  const nextCloseTime = useSelector(state => state.numbergames.draws[0].regCloseTime);
  const _useCloseTimeTicker = useCloseTimeTicker(nextCloseTime),
    hours = _useCloseTimeTicker.hours,
    minutes = _useCloseTimeTicker.minutes,
    seconds = _useCloseTimeTicker.seconds;
  return React.createElement("div", {
    className: "gp-countdown-counter-container ".concat(useDarkBg && 'cell-bg-dark')
  }, React.createElement("p", null, "N\xE4sta spelstopp om:"), React.createElement("div", {
    className: "gp-countdown-counter"
  }, React.createElement(TimeCell, {
    value: hours,
    label: "tim"
  }), React.createElement(Separator, null), React.createElement(TimeCell, {
    value: minutes,
    label: "min"
  }), React.createElement(Separator, null), React.createElement(TimeCell, {
    value: seconds,
    label: "sek"
  })));
};
svs.gamePackage.components.CloseTimeCountdown = CloseTimeCountdown;

 })(window);